import { getUserCurrentDate } from "../utils/getUserCurrentDate";
const ENDPOINT = process.env.REACT_APP_ENDPOINT

const getGame = async () => {
    const formattedDate = getUserCurrentDate();
    const apiUrl = `${ENDPOINT}/snake/?date=${formattedDate}`;
    try {
        const response = await fetch(apiUrl,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status}`);
        }
        const data = await response.json();
        return data
    } catch (error) {
        console.error('Error fetching game:', error);
    }
}

export default getGame;